import axios from 'axios';
import crypto from 'crypto';
import store from '@/store';
import eventHub from './eventHub';

export default {
  // 認証情報を含めてPOST
  send({ path, params = [], options = {}, files = [], callback = null }) {
    // アクセスURLの生成
    let url = process.env.VUE_APP_API_URL + path;
    params.forEach(param => {
      url += '/' + param.toString();
    });

    // 送信データの生成
    let content = Object.assign({}, options);

    // 認証情報の生成
    if (store.state.auth.user_id !== null && store.state.auth.access_key !== null) {
      const randomkey = crypto.randomBytes(64);
      const authKey = crypto
        .createHmac('sha256', randomkey)
        .update(store.state.auth.access_key)
        .digest('hex');
      content.auth = {
        user_id: store.state.auth.user_id,
        random: randomkey.toString('hex'),
        auth_key: authKey,
      };
    }

    // ファイル送信データの生成
    let formData = null;
    if (Object.keys(files).length > 0) {
      formData = new FormData();
      formData.append('json', JSON.stringify(content));
      Object.keys(files).forEach((key) => {
        formData.append(key, files[key]);
      });
    } else {
      formData = content;
    }

    // 送受信
    store.dispatch('common/loadStart', path);
    axios.post(url, formData).then((res) => {
      store.dispatch('common/loadFinish', path);
      if (res.status === 200 || res.status === 304) {
        if (res.data.status) {
          if (callback !== null) {
            callback(res.data);
          }
        } else {
          if (res.data.error === 'auth') {
            eventHub.$emit('logout');
          }
          this.error(res.data.error);
        }
      } else {
        this.error('illegal');
      }
    }).catch((err) => {
      console.log(err);
      store.dispatch('common/loadFinish', path);
      this.error('connect');
    });
  },

  success(code) {
    eventHub.$emit('success', code);
  },

  error(code) {
    eventHub.$emit('error', code);
  },

  confirm(title, message, callback) {
    eventHub.$emit('confirm', title, message, callback);
  },
};
